import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillPlusSquare, AiFillMinusSquare } from "react-icons/ai";
import { FaWindowClose } from "react-icons/fa";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { TbDragDrop } from "react-icons/tb";
import CommonModal from "../CommonModal";
import { editMarkName, getFileDownload, getUploadFile } from "JS/API";
import { generateCompoundImage } from "utils/imageGenerator";

const MarkImageNameEditModal = ({
  setEdit,
  defaultMarkNameArr,
  markType,
  setMarkType,
  isNew,
  setOriginalFileName,
  fileName,
  setFile,
  setImg,
  setImagePath,
  setFileName,
  originalFileName,
  setUploadComplete,
  imagePath,
  onMarkNameUpdated,
  img,
  id
}) => {
  const [markNameArr, setMarkNameArr] = useState(
    defaultMarkNameArr?.length > 0 ? [...defaultMarkNameArr] : [""]
  );
  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [uploadImg, setUploadImg] = useState("");
  const [dragState, setDragState] = useState("leave");
  const [selectedMarkType, setSelectedMarkType] = useState(markType || 'TEXT');


  const navigate = useNavigate();

  const markTypeOptions = [
    { value: 'TEXT', label: '문자상표' },
    { value: 'FIGURE', label: '도형상표' },
    { value: 'COMPOUND', label: '복합상표' }
  ];

  const hidePlusBtn = () => {
    if (selectedMarkType === "COMPOUND") {
      return markNameArr.length >= 2;
    }
    return markNameArr.length >= 5;
  };

  const fileInputRef = useRef(null)

  const renderMarkNameInputs = () => {
    return markNameArr.map((markName, idx) => (
      <div className="row" key={idx}>
        <span>{idx + 1}단</span>
        <input
          className="modal-mark-name-edit-input"
          type="text"
          maxLength={19}
          value={markName}
          onChange={(e) =>
            setMarkNameArr((prev) => {
              const clone = [...prev];
              clone[idx] = e.target.value;
              return clone;
            })
          }
        />
        {idx === 0 ? (
          <AiFillPlusSquare
            style={{ width: "40px", height: "40px" }}
            className={hidePlusBtn() ? "btn-display-none" : ""}
            onClick={() =>
              setMarkNameArr((prev) => {
                const clone = [...prev];
                clone.push("");
                return clone;
              })
            }
          />
        ) : (
          <AiFillMinusSquare
            style={{ width: "40px", height: "40px" }}
            onClick={() =>
              setMarkNameArr((prev) => {
                const clone = [...prev];
                clone.splice(idx, 1);
                return clone;
              })
            }
          />
        )}
      </div>
    ));
  };

  const hanndleAddFn = () => {
    if (
      selectedMarkType !== "TEXT" &&
      !uploadImg
    ) {
      return commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "이미지 파일을 업로드해 주세요."
      );
    }

    const payload = {
      mark_type: selectedMarkType,
    };

    const filteredMarkNames = markNameArr
      .map((name) => name.trim())
      .filter((name) => name !== "");

    if (selectedMarkType !== "TEXT") {
      setOriginalFileName(originalFileName);
      setFileName(fileName);
      setImagePath(imagePath);
    }

    if (selectedMarkType !== "FIGURE") {
      payload.marks = filteredMarkNames.map((name, i) => ({
        mark_step: i + 1,
        mark_name: name,
      }));
    }

    if (typeof onMarkNameUpdated === "function") {
      onMarkNameUpdated(filteredMarkNames);
      setMarkType(selectedMarkType);
    }

    changeState(setEdit, "markImage", false);
    setAlert("completeEdit");
    commonModalSetting(setAlertBox, true, "alert", "상표명이 추가되었습니다.");
  };


  const imgPreview = async (e) => {
    for (let file of e.target.files) {
      setOriginalFileName(file.name);
      setFile(file);

      const reader = new FileReader();
      reader.onload = async () => {
        setImg(reader.result);
        setUploadImg(reader.result);

        const formData = new FormData();
        formData.append("files", file, file.name);
        formData.append("file_type", "logo_agent");

        try {
          const result = await getUploadFile(formData);
          if (typeof result === "object") {
            const originalFileName = result?.data[0]?.original_file_name;
            const fileName = result?.data[0]?.filename;
            const path = result?.data[0]?.path;

            setOriginalFileName(originalFileName);
            setFileName(fileName);
            setImagePath(path);
            setUploadComplete(true);
          } else {
            setUploadComplete(false);
          }
        } catch (error) {
          console.error("원본 이미지 업로드 실패:", error);
          setUploadComplete(false);
        }
      };
      reader.readAsDataURL(file);
    }
  };


  const fetchUploadedImage = async (fileName, originalFileName) => {
    try {
      const response = await getFileDownload(fileName, originalFileName);

      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );

      const mimeType = response.headers["content-type"];
      const imgSrc = `data:${mimeType};base64,${base64}`;
      setImg(imgSrc);
      setUploadImg(imgSrc);
    } catch (error) {
      console.error("이미지 불러오기 실패:", error);
    }
  };


  useEffect(() => {

    if (fileName && originalFileName) {
        console.log('ehlsi')
      fetchUploadedImage(fileName, originalFileName);
    }
  }, [fileName, originalFileName]);



  const [compoundImageFilename, setCompoundImageFilename] = useState("");
  const [compoundImagePath, setCompoundImagePath] = useState("");


  const compoundReadyRef = useRef(false);
  const compoundPayloadRef = useRef(null); // 비동기 API용 payload 저장용 ref


  useEffect(() => {
    if (
      compoundReadyRef.current &&
      compoundImageFilename &&
      compoundImagePath &&
      compoundPayloadRef.current
    ) {
      const compoundPayload = {
        ...compoundPayloadRef.current,
        compound_image_filename: compoundImageFilename,
        compound_image_path: compoundImagePath,
      };

      submitMark(compoundPayload);
      compoundReadyRef.current = false;
      compoundPayloadRef.current = null;
    }
  }, [compoundImageFilename, compoundImagePath]);

  const submitMark = async (payload) => {
    try {
      const response = await editMarkName(id, payload);
      if (response?.data === true || response?.data?.success) {
        commonModalSetting(setAlertBox, true, "alert", "상표명이 수정되었습니다.");
        changeState(setEdit, "markImage", false);
        setMarkType(selectedMarkType);
        if (typeof onMarkNameUpdated === "function") {
          onMarkNameUpdated(payload.marks?.map(m => m.mark_name) || []);
        }
      } else {
        catchError(response, navigate, setAlertBox, setAlert);
      }
    } catch (err) {
      catchError(err, navigate, setAlertBox, setAlert);
    }
  };

  const handleSubmit = async () => {
    if (selectedMarkType !== "TEXT" && !uploadImg) {
      return commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "이미지 파일을 업로드해 주세요."
      );
    }

    const filteredMarkNames = markNameArr
      .map((name) => name.trim())
      .filter((name) => name !== "");

    const basePayload = {
      mark_type: selectedMarkType,
    };

    if (selectedMarkType !== "FIGURE") {
      basePayload.marks = filteredMarkNames.map((name, i) => ({
        mark_step: i + 1,
        mark_name: name,
      }));
    }

    if (selectedMarkType !== "TEXT") {
      basePayload.image_original_filename = originalFileName;
      basePayload.image_filename = fileName;
      basePayload.image_path = imagePath;
    }

    if (selectedMarkType === "COMPOUND" && uploadImg) {
      try {
        compoundReadyRef.current = true;
        compoundPayloadRef.current = basePayload;

        await generateCompoundImage(
          uploadImg,
          filteredMarkNames,
          setCompoundImageFilename,
          setCompoundImagePath
        );
      } catch (err) {
        console.error("복합상표 이미지 생성/업로드 실패:", err);
        return commonModalSetting(setAlertBox, true, "alert", "복합상표 이미지 생성에 실패했습니다.");
      }
      return;
    }

    submitMark(basePayload);
  };



  return (
    <>
      <div className="modal-background">
        <div
          className="modal-inquiry-container"
          style={{ width: "550px", minHeight: "600px", height: 'auto' }}
        >
          <div className="modal-inquiry_header">
            <h3>상표 유형 수정</h3>
            <div className="mark-type-selector">
              <select
                value={selectedMarkType}
                onChange={(e) => {
                  const newType = e.target.value;
                  setSelectedMarkType(newType);

                  // 상태 초기화
                  setMarkNameArr([""]);
                  setUploadImg("");
                  setOriginalFileName("");
                  setFileName("");
                  setImagePath("");
                  setFile(null);
                  setImg("");
                  setUploadComplete(false);
                }}
              >
                {markTypeOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

            </div>
            <div
              className="modal-inquiry-close"
              onClick={() => {
                setAlert("cancel");
                commonModalSetting(
                  setAlertBox,
                  true,
                  "confirm",
                  "정말 취소하시겠습니까?<br/>지금까지 수정된 내용은 반영되지 않습니다."
                );
              }}
            >
              <FaWindowClose />
            </div>
          </div>

          <div className="modal-mark-name-edit"
          >
            {selectedMarkType === "TEXT" && (
              <>
                <div className="modal-mark-name-edit-inputs">
                  {renderMarkNameInputs()}
                </div>

                {uploadImg && (
                  <button
                    style={{
                      backgroundColor: '#59595a',
                      color: 'white',
                      padding: '5px',
                      borderRadius: '5px'
                    }}
                    className="delete-img-btn"
                    onClick={() => {
                      setUploadImg("");
                      setOriginalFileName("");
                      setFileName("");
                      setImagePath("");
                      setFile(null);
                      setImg("");
                      setUploadComplete(false);
                      if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                      }
                    }}
                  >
                    이미지 삭제
                  </button>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #888888",
                    borderRadius: "10px",
                    height: "60%",
                    width: "80%",
                    marginBottom: "10px",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  <input
                    type="file"
                    onChange={imgPreview}
                    accept="image/*"
                    id="fileInput"
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                  />

                  {img ? (
                    <label className="imageInput" htmlFor="fileInput">
                      <img
                        style={{ maxHeight: '230px', maxWidth: '420px' }}
                        src={img} alt="업로드된 이미지" />
                    </label>
                  ) : (
                    <label
                      htmlFor="fileInput"
                      style={{ cursor: 'pointer' }}
                      className={`imageInput column ${dragState}`}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const files = e.dataTransfer?.files;
                        if (!files || files.length === 0) return;

                        if (files.length > 1) {
                          return commonModalSetting(
                            setAlertBox,
                            true,
                            "alert",
                            "한 장만 업로드하실 수 있습니다."
                          );
                        }
                        imgPreview();
                      }}
                      onDragEnter={() => setDragState("enter")}
                      onDragLeave={() => setDragState("leave")}
                    >
                      <TbDragDrop />
                      <span>이미지가 있다면 업로드해 주세요.</span>
                    </label>
                  )}
                </div>
              </>
            )}
            {selectedMarkType !== "TEXT" && (
              <>
                <div className="header">
                  {selectedMarkType === "COMPOUND" && (
                    <>
                      <span>복합 상표는</span>
                      <span>최대 2단까지 입력 가능합니다.</span>
                    </>
                  )}
                </div>
                {uploadImg && (
                  <button
                    style={{
                      backgroundColor: '#59595a',
                      color: 'white',
                      padding: '5px',
                      borderRadius: '5px'
                    }}
                    className="delete-img-btn"
                    onClick={() => {
                      setUploadImg("");
                      setOriginalFileName("");
                      setFileName("");
                      setImagePath("");
                      setFile(null);
                      setImg("");
                      setUploadComplete(false);
                      if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                      }
                    }}
                  >
                    이미지 삭제
                  </button>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #888888",
                    borderRadius: "10px",
                    height: "60%",
                    width: "80%",
                    marginBottom: "10px",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  <input
                    type="file"
                    onChange={imgPreview}
                    accept="image/*"
                    id="fileInput"
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                  />

                  {img ? (
                    <label className="imageInput" htmlFor="fileInput">
                      <img
                        style={{
                          maxHeight: '230px',
                          maxWidth: '420px'
                        }}
                        src={img} alt="업로드된 이미지" />
                    </label>
                  ) : (
                    <label
                      htmlFor="fileInput"
                      style={{
                        cursor: 'pointer'
                      }}
                      className={`imageInput column ${dragState}`}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const files = e.dataTransfer?.files;
                        if (!files || files.length === 0) return;

                        if (files.length > 1) {
                          return commonModalSetting(
                            setAlertBox,
                            true,
                            "alert",
                            "한 장만 업로드하실 수 있습니다."
                          );
                        }
                        imgPreview();
                      }}

                      onDragEnter={() => setDragState("enter")}
                      onDragLeave={() => setDragState("leave")}
                    >
                      <TbDragDrop />
                      <span>이미지를 업로드해 주세요.</span>
                    </label>
                  )}
                </div>
              </>
            )}
            {selectedMarkType === "COMPOUND" && (
              <div className="modal-mark-name-edit-inputs">
                {renderMarkNameInputs()}
              </div>
            )}
          </div>
          <div className="modal-mark-name-edit-btn-group">
            {isNew ? (
              <button onClick={hanndleAddFn}>추가</button>
            ) : (
              <button onClick={handleSubmit}>수정</button>

            )}
            <button
              onClick={() => {
                setAlert("cancel");
                commonModalSetting(
                  setAlertBox,
                  true,
                  "confirm",
                  "정말 취소하시겠습니까?<br/>지금까지 수정된 내용은 반영되지 않습니다."
                );
              }}
            >
              취소
            </button>
          </div>
        </div>
      </div>
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "cancel" || alert === "completeEdit")
              changeState(setEdit, "markImage", false);
            else if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}
    </>
  );
};

export default MarkImageNameEditModal;
